import type { IRootState } from '../root-reducer';

export const getUserInfo = (state: IRootState) => state?.userInfoApi?.userInfo;
